import { forgotPasswordSchema } from "@closer/shared";
import { Button, FormField, Input, useToast } from "@closer/ui";
import { useState } from "react";
import { Link } from "react-router";
import type { z } from "zod";

import { LockIcon } from "../../components/icons";
import { AuthLayout } from "../../layouts/AuthLayout";
import { api, ApiRequestError } from "../../lib/apiClient";
import { applyServerErrors, useZodForm } from "../../lib/useZodForm";

/**
 * ŞİFREMİ UNUTTUM (CLOS-64 `[016]`; ekran yarısı CLOS-369 `[S05]`).
 *
 * ⚠ Hesap varlığı İFŞA EDİLMEZ: adres kayıtlı olsun olmasın aynı mesaj döner. Kartın ilk
 * kabul kriteri bu ve ekran onu sunucudan devralıyor — istemci kendi başına "böyle bir
 * kullanıcı yok" demiyor.
 */

type ForgotValues = z.infer<typeof forgotPasswordSchema>;

export function ForgotPasswordPage() {
  const toast = useToast();
  const [sentMessage, setSentMessage] = useState<string | null>(null);
  const form = useZodForm(forgotPasswordSchema, {
    defaultValues: { email: "" } as ForgotValues,
  });

  const onSubmit = form.handleSubmit(async (values) => {
    try {
      const { data } = await api<{ message: string }>("/api/session/forgot-password", {
        method: "POST",
        body: JSON.stringify(values),
      });
      setSentMessage(data.message);
    } catch (error) {
      applyServerErrors(form, error);
      toast.error(
        error instanceof ApiRequestError
          ? error.message
          : "İşlem tamamlanamadı. Lütfen tekrar deneyin.",
      );
    }
  });

  return (
    <AuthLayout
      title="Şifremi unuttum"
      description="Kayıtlı e-posta adresinizi girin, size şifrenizi yenilemeniz için bir bağlantı gönderelim."
      icon={<LockIcon className="size-6" />}
    >
      {sentMessage ? (
        <div className="flex flex-col gap-4">
          <p role="status" className="text-sm text-fg-muted">
            {sentMessage}
          </p>
          <Link to="/login" className="text-center font-medium text-primary hover:underline">
            Giriş sayfasına dön
          </Link>
        </div>
      ) : (
        <form onSubmit={onSubmit} noValidate className="flex flex-col gap-4">
          <p className="text-sm text-fg-soft">
            Hesabınızın e-posta adresini girin; sıfırlama bağlantısını gönderelim.
          </p>
          <FormField label="E-posta" error={form.formState.errors.email?.message} required>
            <Input type="email" autoComplete="email" {...form.register("email")} />
          </FormField>
          <Button type="submit" loading={form.formState.isSubmitting}>
            Sıfırlama Bağlantısı Gönder
          </Button>
          <p className="text-center text-sm text-fg-soft">
            <Link to="/login" className="font-medium text-primary hover:underline">
              Giriş sayfasına dön
            </Link>
          </p>
        </form>
      )}
    </AuthLayout>
  );
}
